import { createFileRoute } from "@tanstack/react-router"
import { AddGmailIntegration } from "modules/settings/components/integrations/gmail/AddGmailIntegration"
import { z } from "zod"

const GmailIntegrationCallbackSearchSchema = z.object({
  code: z.string().optional(),
  error: z.string().optional(),
  error_description: z.string().optional(),
})

export const Route = createFileRoute("/_base/_auth/settings/channels/gmail/new")({
  component: AddGmailIntegration,
  validateSearch: (search: Partial<z.infer<typeof GmailIntegrationCallbackSearchSchema>>) => {
    return GmailIntegrationCallbackSearchSchema.parse(search)
  },
})
